// extracted by mini-css-extract-plugin
export default {"switchContainer":"MapList_switchContainer__6w7T+","switchContainer_right":"MapList_switchContainer_right__alqww","map":"MapList_map__ZgreZ","cardList":"MapList_cardList__koNxB"};